// extracted by mini-css-extract-plugin
export default {"content":"TableRowColumnExtended__content-troQd","active":"TableRowColumnExtended__active-LyWxm","disable":"TableRowColumnExtended__disable-Y6Qui"};